module.exports = __webpack_public_path__ + "static/media/Novinbit.44a74757.png";